import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css'
import ApiService from './services/api.service'

// ResizeObserver can report a benign loop warning during layout — ignore in dev overlay.
window.addEventListener('error', (event) => {
  if (event.message?.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation();
  }
});

function isVueKeepAliveHmrRace(error) {
  const message = String(error?.message || error || '');
  const stack = String(error?.stack || '');
  return (
    message.includes("Cannot read properties of null (reading 'component')") &&
    stack.includes('locateNonHydratedAsyncRoot')
  );
}

window.addEventListener('error', (event) => {
  if (isVueKeepAliveHmrRace(event.error || event.message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (isVueKeepAliveHmrRace(event.reason)) {
    event.preventDefault();
  }
});

// Import UI mode CSS files (global overrides)
import './styles/ui-modes/default.css'
import './styles/ui-modes/compact.css'
import './styles/glass-tab-view.css'
import './styles/glass-tab-panel.css'
import './modules/consultant/styles/label-field-tokens.css'
import './modules/consultant/styles/label-field-glass-forms.css'

// Initialize API Service with base URL
ApiService.init(process.env.VUE_APP_API_URL || 'http://localhost:5000/api')
ApiService.setHeader()

const app = createApp(App)

// Dev/HMR: Vue keep-alive + async route swap can throw inside Suspense internals.
app.config.errorHandler = (err, instance, info) => {
  if (isVueKeepAliveHmrRace(err)) return;
  // eslint-disable-next-line no-console
  console.error('[Vue]', info, err, instance);
};

app.use(store)
app.use(router)
app.use(VueToast)

app.mount('#app') 